module.exports = __webpack_public_path__ + "img/social-comment.76692420.png";